<template>
  <message-screen icon="note" message="Select a note"/>
</template>

<script>
import MessageScreen from '@/components/core/MessageScreen.vue';

export default {
  name: 'NoNote',
  components: {
    MessageScreen,
  },
};
</script>

<style lang="scss" scoped>
.message {
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>
